<template>
    <div class="user-info-component">
        <el-form ref="modelForm" :model="modelForm" label-width="70px" size="small" :rules="modelFormRules">
            <el-form-item prop="cover" label="头像">
                <el-upload class="avatar-uploader" action="/room/upload/img" :headers="headers" name="mulFile"
                    :data="{ key: 'head' }" :show-file-list="false"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="modelForm.heads" :src="modelForm.heads" class="avatar">
                    <div v-else class="avatar-uploader-icon">
                        <i class="el-icon-plus"></i>
                        <!-- <span>上传图片</span> -->
                    </div>
                    <div slot="tip" class="el-upload__tip"
                        style="width: 250px;line-height: 20px;font-size: 11px;color: #999999;">支持jpg .png格式，大小不超过500kb</div>
                </el-upload>
            </el-form-item>
            
            <el-form-item label="用户名" prop="username">
                <el-input type="text" v-model="modelForm.username" disabled style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item label="昵称" prop="nickname">
                <el-input type="text" v-model="modelForm.nickname" style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input type="text" v-model="modelForm.phone" style="width: 250px"></el-input>
            </el-form-item>
        </el-form>

        <div class="footer" style="margin:0 20px;text-align:center;">
            <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            <el-button type="text" @click="handleResetForm">清空</el-button>

        </div>
    </div>
</template>


<script>
export default {
    computed: {
        headers() {
            return {
                "Authorization": localStorage.getItem('Token'),
            }
        },
    },
    data() {
        const validatePhone = (rule, value, callback) => {
            let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (!reg.test(value)) {
                callback(new Error("手机号格式错误"));
            } else {
                callback();
            }
        }
        return {
            modelFormRules: {
                nickname: [{ required: true, message: "请输入昵称", trigger: "blur" }],
                phone: [{ validator: validatePhone, trigger: 'blur' }],
            },
            modelForm: {},
            submitLoading: false
        }
    },
    mounted() {
        this.getUserInfo();
    },
    methods: {
        handleSubmit(fromName) {
            this.$refs[fromName].validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    this.postRequest('/api/user/modify', this.modelForm)
                    .then(res => {
                        this.submitLoading = false;
                        let data = res.data;
                        if (data.code == 200) {
                            this.$message.success('修改成功');
                            this.getUserInfo();
                        }
                    }).catch(() => {
                        this.submitLoading = false;
                    })
                }
            })
        },
        handleResetForm() {
            this.getUserInfo();
        },
        handleAvatarSuccess(res) {
            this.modelForm.heads = res.data;
        },
        beforeAvatarUpload(file) {
            const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/jpg') || (file.type === 'image/png');
            const isLt2M = file.size / 1024 < 500;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 500kb!');
            }
            return isJPG && isLt2M;
        },
        getUserInfo() {
            const userId = localStorage.getItem('userId')
            this.getRequest('/api/user/get/' + userId)
                .then(res => {
                    let data = res.data;
                    if(data.code == 200) {
                        this.modelForm = data.data;
                    }
                })
                .catch(err => {
                    // console.log(err);
                })
        }
    },
}
</script>